import axios from 'axios'
import moment from 'moment-timezone'

import i18n from '@/i18n'

import unauthorizedHandler from '@/axios/helpers/unauthorizedHandler'
import conflictHandler from '@/axios/helpers/conflictHandler'

import configuration from '@/classes/Configuration'

import router from '@/router'
import store from '@/store'

const isHandlerEnabled = (config) => !(config.hasOwnProperty('enableHandler') && !config.enableHandler)

const portalApi = axios.create({
  baseURL: `${configuration.get('portalApi')}/api/portal`,
  headers: { 'Time-Zone': moment.tz.guess() }
})

// Add Authorization header
portalApi.interceptors.request.use((config) => {
  return new Promise((resolve) => {
    if (config.isPublic || config.headers['Authorization']) {
      return resolve(config)
    }

    const tokenPromise = new Promise((resolve) => {
      if (store.getters.isAuthorized()) {
        resolve(store.state.authorization.credentials.accessToken)
      } else {
        return unauthorizedHandler(config).then(token => {
          resolve(token)
        }).catch(() => {
          store.dispatch('showMessage', { title: i18n.t('sentence.refreshTokenErrorMessage'), options: { variant: 'danger' } })
          router.replace('/')
        })
      }
    })

    tokenPromise.then(token => {
      config.headers['Authorization'] = `Bearer ${token}`

      return resolve(config)
    })
  })
})

// Handle errors
portalApi.interceptors.response.use(undefined, error => {
  if (!axios.isCancel(error)) {
    const { config, response: { status, data } } = error

    if (isHandlerEnabled(config)) {
      if (status >= 400 && status < 500) {
        if (status === 401) {
          return unauthorizedHandler(config).then(token => {
            config.headers['Authorization'] = `Bearer ${token}`

            return portalApi(config)
          }).catch(() => {
            router.replace('/')
          })
        } else if (status === 409) {
          return conflictHandler(error)
        } else if (data.errorReport && data.errorReport.errors) {
          data.errorReport.errors.forEach(error => {
            store.dispatch('showMessage', { title: error.message, autoHideDelay: 5000, options: { variant: 'danger' } })
          })
        } else {
          store.dispatch('showMessage', { title: i18n.t('sentence.generalErrorMessage'), autoHideDelay: 5000, options: { variant: 'danger' } })
        }
      } else {
        store.dispatch('showMessage', { title: i18n.t('sentence.generalErrorMessage'), autoHideDelay: 5000, options: { variant: 'danger' } })
      }
    }

    return Promise.reject(error)
  } else {
    console.warn('Request canceled', error.message)
    return new Promise(() => {})
  }
})

export default portalApi
